import { MutipleJumpCondition } from '@/libs/enum';
/**
 * 用来判断是否满足多选题的跳转条件
 */
export default class MutiJumpConditonJudge {
    // 判断两个数组，数组2的元素是否都在数组1中
    isSubset(arr1, arr2) {
        return arr2.every(element => arr1.includes(element));
    }

    /**
     * 判断是否满足多选题的跳转
     */
    isValidMultipleJumpCondition(answer = [], jumpCondition, jumpConditionOptionIdentifiers = []) {
        let result = false;
        if (!answer || !answer.length) {
            return result;
        }
        // 配置了【选择了任意一个】
        if (jumpCondition === MutipleJumpCondition.selectAny) {
            result = answer.some(id => {
                return jumpConditionOptionIdentifiers.includes(id);
            });
        }
        // 配置了【选择了全部】
        else if (jumpCondition === MutipleJumpCondition.selectAll) {
            result = this.isSubset(answer, jumpConditionOptionIdentifiers);
        }
        // 配置了【没有选择任意一个】
        else if (jumpCondition === MutipleJumpCondition.notSelectAny) {
            result = !answer.some(id => {
                return jumpConditionOptionIdentifiers.includes(id);
            });
        }
        // 配置了【没有选择全部】
        else if (jumpCondition === MutipleJumpCondition.notSelectAll) {
            result = !this.isSubset(answer, jumpConditionOptionIdentifiers);
        }
        return result;
    }
}
